import { type MessagePayload } from "@/shared/webworker";

export enum MapDataEvent {
  Error = "error",
  Initialized = "initialized",
}

export interface MapDataEventPayloadMap {
  [MapDataEvent.Error]: Error;
  [MapDataEvent.Initialized]: undefined;
}

export function isInitializedEvent(
  event: MessageEvent<MessagePayload>,
): event is MessageEvent<
  MessagePayload<MapDataEvent, MapDataEventPayloadMap[MapDataEvent.Initialized]>
> {
  return event.data.type === MapDataEvent.Initialized;
}
